/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#main-container[_ngcontent-%COMP%]{margin-bottom:40px}.nav[_ngcontent-%COMP%]{padding:0;margin:10px 0 0;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.nav[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin:1px 0 -1px}.nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding:15px 30px;font-size:1.6rem}"];
export { styles as styles };
